import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  users: 'Users',
  totalUsers: 'Total users',
  learners: 'Learners',
  instructors: 'Instructors',
  available: 'Available',
  creators: 'Creator licenses',
  addCreators: 'Add licenses',
  availableOnlyForBusinessPlan: 'Available in Business and Enterprise plans',
  aiActionsUsed: 'AI credits',
  avaialbleBalance: 'Available balance',
  upgradeForMoreActions: 'Add credits',
  appSettingsTitle: 'App settings',
  appSettingsSubtitle: 'Control the learner app experience for your workspace.',
  spaceQuota: 'Storage quota',
  buyMoreSpace: 'Expand storage',
  notAvailableForTrialPlan: 'Not available for trial plan',
  usersAndLicenses: 'Users & licenses',
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  editRole: 'Edit user role',
  deleteUser: 'Delete user',
  activateUser: 'Activate user',
  areYouSure: 'Are you sure you want to delete ',
  username: 'Name',
  email: 'Email',
  type: 'Type',
  status: 'Status',
  actions: 'Actions',
  invite: 'Invite new users',
  inviteSubtitle: 'Add users and assign their roles.',
  userEmail: 'User email',
  role: 'Role',
  selectRole: 'Select user role',
  inviteAction: 'Invite',
  youSureDeleteMember: 'Are you sure you want to delete this Workspace member?',
  staffEditSubtitle: 'Assign user a different role',
  memberDeleted: 'User deleted',
  memberActivated: 'User activated',
  somethingWentWrong: 'Something went wrong',
  ltiPrompt:
    'Enhance your educational experience effortlessly with our LTI integration. Seamlessly connect external tools and resources to your learning management system, simplifying access and fostering a cohesive learning environment for both educators and learners.',
  setupLti: 'Setup LTI integration now',
  newLtiIntegration: 'New LTI platform integration',
  ltiName: 'Name',
  ltiNamePlaceholder: 'Platform name',
  platformType: 'LMS system',
  platformTypePlaceholder: 'Select your LMS system',
  accessTokenUrl: 'Access token URL',
  accessTokenPlaceholder: 'Access token URL (can be found in your LMS)',
  authorizeUrl: 'Authorize URL',
  authorizeUrlPlaceholder: 'Authorize URL (can be found in your LMS)',
  issuer: 'Issuer',
  issuerPlaceholder: 'Issuer (can be found in your LMS)',
  jwkSetUrl: 'JWK set URL',
  jwkSetUrlPlaceholder: 'JWK set URL (can be found in your LMS)',
  clientId: 'Client ID',
  clientIdPlaceholder: 'Client ID (can be found in your LMS)',
  toolDataTitle: 'tapybl LTI tool',
  loginUrl: 'Login URL',
  redirectionUrl: 'Redirection URL',
  publicKeySetUrl: 'Public key set URL',
  yourPlatforms: 'Your platforms',
  addNewPlatform: 'Add new platform',
  noPlatforms: "Looks like you don't have any platforms configured yet",
  ltiConnection: 'LTI connection',
  upgradeNow: 'Upgrade now!',
  editIntegration: 'Edit integration',
  deleteIntegration: 'Delete integration',
  areYouSureDeletePlatform: 'Are you sure you want to delete this platform?',
  delete: 'Delete',
  copyEmail: 'Copy email',
  expirationDate: 'Next billing date',
  cardDetails: 'Card details',
  unscubscribeInfo:
    'You can cancel your subscription at any time by clicking the link below',
  unsubscribe: 'Cancel subscription',
  areYouSureCancelSubscription:
    'Are you sure you want to cancel your subscription?',
  trialSubscription: 'Trial subscription',
  subscriptionTier: 'Subscription tier',
  upgradeToUseLti: 'Upgrade subscription plan to use LTI',
  changePaymentMethodInfo:
    'Update or change the credit card linked to your workspace by clicking the link below',
  changePaymentMethod: 'Update payment method',
  invoices: 'Plans and invoices',
  otherActions: 'Billing and payments',
  viewPdf: 'View PDF',
  setupVimeoStorage: 'Setup Vimeo integration',
  vimeoClientSecret: 'Vimeo access token',
  vimeoClientPlaceholder: 'Access token',
  vimeoAdded: 'Vimeo integration setup success',
  vimeoPrompt:
    'Easily access and manage your Vimeo-hosted videos with our seamless integration system. Streamline your experience by effortlessly browsing and selecting your video content directly from Vimeo, all within our platform. Enjoy the convenience of centralized management while maximizing the potential of your Vimeo library.',
  vimeoConfigured: 'Your key has been added',
  invitationSent: 'Invitation sent',
  resendInvitation: 'Resend invitation',
  resendInvitationSuccess: 'Invitation resent successfully',
  resendInvitationFail: 'Failed to resend invitation',
  detailsUpdated: 'Workspace details updated',
  vimeoClientSecretInstructions:
    'For help configuring your Vimeo integration, check out our setup guide: ',
  ltiClientSecretInstructions:
    'For help configuring your LTI integration, check out our setup guide: ',
  removeIntegration: 'Remove integration',
  removeVimeoIntegration:
    'Are you sure you want to remove your current Vimeo integration?',
  removeVimeoIntegrationWarning:
    'Warning: This will remove all Vimeo-connected videos in your lessons.',
  featuresList: 'Full list of features',
  editConfirmation: 'Are you sure you want to change the role for this user?',
  editRoleSuccess: 'User role changed',
  subscriptionCancelledMessage: (endDate: string) =>
    `Your subscription has been cancelled. You have access until ${endDate}.`,
  subscriptionExpiredMessage:
    'Your subscription has expired. To continue using tapybl without interruption, please renew your plan.',
  noInvoicesFound: 'Hang tight! Your data will appear here once it’s ready.',
};

const welsh = {
  users: 'Defnyddwyr',
  totalUsers: 'Cyfanswm defnyddwyr',
  learners: 'Dysgwyr',
  instructors: 'Hyfforddwyr',
  available: 'Ar gael',
  creators: 'Trwyddedau creu',
  addCreators: 'Ychwanegu trwyddedau',
  availableOnlyForBusinessPlan: 'Ar gael yn y cynllun busnes yn unig',
  aiActionsUsed: 'Credydau AI',
  avaialbleBalance: 'Balans sydd ar gael',
  upgradeForMoreActions: 'Ychwanegu credydau',
  appSettingsTitle: 'Gosodiadau’r ap',
  appSettingsSubtitle: 'Rheoli profiad ap y dysgwr ar gyfer eich gweithle.',
  spaceQuota: 'Cwota storfa',
  buyMoreSpace: 'Ehangu storfa',
  notAvailableForTrialPlan: 'Nid yw ar gael ar gynllun prawf',
  usersAndLicenses: 'Defnyddwyr a thrwyddedau',
  save: 'Cadw',
  cancel: 'Canslo',
  edit: 'Golygu',
  editRole: 'Golygu rôl y defnyddiwr',
  deleteUser: 'Dileu defnyddiwr',
  activateUser: 'Gweithredu defnyddiwr',
  areYouSure: "Ydych chi'n siŵr eich bod am ddileu?",
  username: 'Enw',
  email: 'e-bost',
  type: 'Math',
  status: 'Statws',
  actions: 'Gweithredoedd',
  invite: 'Gwahodd defnyddwyr newydd',
  inviteSubtitle: 'Ychwanegwch ddefnyddwyr a dyrannwch eu rôl.',
  userEmail: 'E-bost y defnyddiwr',
  role: 'Rôl',
  selectRole: 'Dewis rôl y defnyddiwr',
  inviteAction: 'Gwahodd',
  youSureDeleteMember:
    "Ydych chi'n siŵr eich bod am ddileu aelod y Gweithle hwn?",
  staffEditSubtitle: "Dyrannwch rôl wahanol i'r defnyddiwr",
  memberDeleted: "Defnyddiwr wedi'i ddileu",
  memberActivated: "Defnyddiwr wedi'i weithredu",
  somethingWentWrong: "Rhoddodd rhywbeth o'i le",
  ltiPrompt:
    "Gwella eich profiad addysgol yn ddi-dor gyda'n hymintegraeth LTI. Cysylltwch yn ddi-dor â'ch system rheoli dysgu â'r offer ac adnoddau allanol, gan simplifio'r mynediad a meithrin amgylchedd dysgu cydlynol i'r athrawon a'r myfyrwyr.",
  setupLti: 'Sefydlwythwch Integreiddio LTI nawr',
  newLtiIntegration: 'ntegreiddio llwyfan LTI newydd',
  ltiName: 'Enw',
  ltiNamePlaceholder: 'Llwyfan enw',
  platformType: 'System LMS',
  platformTypePlaceholder: 'Dewiswch eich system LMS',
  accessTokenUrl: 'URL y tocyn mynediad',
  accessTokenPlaceholder:
    'URL y tocyn mynediad (gallwch ei ddod o hyd iddo yn eich system LMS)',
  authorizeUrl: 'URL awdurdodi',
  authorizeUrlPlaceholder:
    'URL awdurdodi (gallwch ei ddod o hyd iddo yn eich system LMS)',
  issuer: 'Cyhoeddwr',
  issuerPlaceholder:
    'Cyhoeddwr (gallwch ei ddod o hyd iddo yn eich system LMS)',
  jwkSetUrl: 'URL set JWK',
  jwkSetUrlPlaceholder:
    'URL set JWK (gallwch ei ddod o hyd iddo yn eich system LMS)',
  clientId: 'ID y cwsmer',
  clientIdPlaceholder:
    'ID y cwsmer (gallwch ei ddod o hyd iddo yn eich system LMS)',
  toolDataTitle: 'tapybl teclyn LTI',
  loginUrl: 'URL mewngofnodi',
  redirectionUrl: 'URL cyfeirio',
  publicKeySetUrl: 'URL set allweddol gyhoeddus',
  yourPlatforms: 'Eich llwyfannau',
  addNewPlatform: 'Ychwanegwch llwyfan newydd',
  noPlatforms:
    "Mae'n edrych fel nad oes gennych unrhyw lwyfannau wedi'u ffurfweddu eto",
  ltiConnection: 'Cysylltiad LTI',
  upgradeNow: 'Uwchraddio nawr!',
  editIntegration: "Golygu'r integreiddio",
  deleteIntegration: 'Dileu integreiddio',
  areYouSureDeletePlatform:
    "Ydych chi'n siŵr eich bod am ddileu'r llwyfan hwn?",
  delete: 'Dileu',
  copyEmail: 'Copïo e-bost',
  expirationDate: 'Dyddiad bilio nesaf',
  cardDetails: 'Manylion y cerdyn',
  unscubscribeInfo:
    "Os dymunwch, mae gennych y dewis i ddad-gofrestru o'ch Cynllun cyfredol",
  unsubscribe: 'Canslo tanysgrifiad',
  areYouSureCancelSubscription:
    "Ydych chi'n siŵr eich bod am ganslo'ch tanysgrifiad?",
  trialSubscription: 'Tanysgrifiad treial',
  upgradeToUseLti: "Gwella'ch cynllun tanysgrifiad i ddefnyddio LTI",
  changePaymentMethodInfo:
    'Os oes angen i chi ddiweddaru eich cerdyn neu ei newid, cliciwch ar y ddolen isod',
  changePaymentMethod: "Diweddaru'r dull taliad",
  invoices: 'Anfonebau',
  otherActions: 'Gweithredoedd eraill',
  viewPdf: 'Gweld PDF',
  setupVimeoStorage: 'Sefydlwch integreiddio Vimeo',
  vimeoClientSecret: 'Tocyn mynediad Vimeo',
  vimeoClientPlaceholder: 'Tocyn mynediad',
  vimeoAdded: 'Llwyddiant gweithredu integreiddio Vimeo',
  vimeoPrompt:
    "Cyrchwch a rheolwch eich fideos sydd wedi'u cynnal ar Vimeo yn hawdd gyda'n system integreiddio ddi-dor. Gwella eich profiad trwy grwydro a dewis eich cynnwys fideo yn ddi-dor yn uniongyrchol o Vimeo, popeth o fewn ein platfform. Mwynhewch y cyfleustra o reoli canolog tra'n gwella potensial eich llyfrgell Vimeo.",
  vimeoConfigured: "Mae eich allwedd wedi'i hychwanegu",
  invitationSent: "Gwahoddiad wedi'i anfon",
  resendInvitation: 'Ailanfonwch wahoddiad',
  resendInvitationSuccess: "Gwahoddiad wedi'i ailanfon yn llwyddiannus",
  resendInvitationFail: 'Methwyd ag ailanfon gwahoddiad',
  detailsUpdated: "Manylion y gweithle wedi'u diweddaru",
  vimeoClientSecretInstructions:
    'Am gymorth gyda chyflunio eich integreiddio Vimeo, edrychwch ar ein canllaw gosod ',
  ltiClientSecretInstructions:
    'Am gymorth gyda chyflunio eich integreiddio LTI, edrychwch ar ein canllaw gosod ',
  removeIntegration: "Tynnu'r integreiddio",
  removeVimeoIntegration:
    "Ydych chi'n siŵr eich bod am dynnu'ch integreiddio Vimeo cyfredol?",
  removeVimeoIntegrationWarning:
    "Rhybudd: Bydd hyn yn tynnu pob fideo sydd wedi'u cysylltu â Vimeo yn eich gwersi",
  editConfirmation: 'Are you sure you want to change the role for this user?',
  editRoleSuccess: 'User role changed',
  subscriptionCancelledMessage: (endDate: string) =>
    `Mae eich tanysgrifiad wedi’i ganslo. Bydd gennych fynediad tan ${endDate}.`,
  subscriptionExpiredMessage:
    'Mae eich tanysgrifiad wedi dod i ben. I barhau i ddefnyddio tapybl heb unrhyw dorriadau, adnewyddwch eich cynllun, os gwelwch yn dda.',
  noInvoicesFound:
    'Arhoswch funud! Bydd eich data yn ymddangos yma unwaith y bydd yn barod.',
};

export const settingsText: any = getLocalizationBasedOnLang(english, welsh);
